export default "__VITE_PUBLIC_ASSET__47186dca__"